import React from 'react';
import styles from './ContactCard.module.css';
import { MdEmail } from 'react-icons/md';
import { BsFillTelephoneFill } from 'react-icons/bs';

const ContactCard = (props) => {
  return (
    <div className={styles.contact_card}>
      <h2 className={styles.cards_name}>{props.name}</h2>
      <h3 className={styles.cards_title}>{props.title}</h3>
      <h5 className={styles.cards_email_box}>
        <MdEmail />
        <a href={`mailto:${props.email}`} className={styles.cards_email}>
          {props.email}
        </a>
      </h5>
      {props.extNumber ? (
        <h5 className={styles.cards_extension}>
          <BsFillTelephoneFill />
          {props.extNumber}
        </h5>
      ) : (
        <></>
      )}
    </div>
  );
};

export default ContactCard;
